<template>
  <div class="login-page">
    <div id="">
      <div class="loginregister">
        <app-language :page="'login'"> </app-language> 
      </div>
      <div class="login-page">
        <div class="login-holder center-div wow fadeIn">
          <img width="145" src="assets/images/logo.svg" alt="" />
          <h1>{{$t('auth.client_login')}}</h1>
          <div class="form-holder">
            <Form v-if="!store.verificationRequired" @submit="submit">
              <ul>
                <li>
                  <label for="">{{$t('auth.email_address')}}</label>
                  <Field
                    class="form-control"
                    name="Email address"
                    rules="required|email"
                    v-model="form.email"
                  />
                  <ErrorMessage name="Email address" class="errorMsg" />
                </li>
                <li class="full-width f-left">
                  <label for="">{{$t('auth.Password')}}</label>
                  <div style="position: relative">
                    <Field
                      :type="inputtype"
                      class="form-control"
                      name="password"
                      v-model="form.password"
                      rules="required|min:6"
                    />
                   <vue-feather :type="iconType" class="toggle-password" @click.prevent="switchVisibility"></vue-feather>
                  </div>
                  <ErrorMessage name="password" class="errorMsg" />
                </li>
                <li class="clearfix">
                  <div class="checkbox checkbox2 f-left">
                    <input type="checkbox" name="" value="" />
                    <span></span>
                    <p>{{$t('auth.remember_me')}}</p>
                  </div>
                  <router-link to="/forgot-password" class="f-right"
                    >{{$t('auth.forgot_password')}}</router-link
                  >
                </li>
                <li class="clearfix">
                  <Field type="hidden" class="form-control" name="Captcha" rules="required" v-if="!captcha_code"/>
                  <vue-recaptcha sitekey="6LcMqxknAAAAALNyz26mKJtR9N-Atb-FKDPHDYb8"
                     size="normal" 
                     theme="light"
                     hl="en"
                     :loading-timeout="30000"
                     @verify="recaptchaVerified"
                     @expire="recaptchaExpired"
                     @fail="recaptchaFailed"
                     @error="recaptchaError"
                     ref="vueRecaptcha"/>
                  <ErrorMessage name="Captcha" class="errorMsg" />
                </li>
              </ul>
              <div class="btn-holder">
                <button type="submit" class="btn btn-yellow">
                  <span>{{$t('auth.login')}}</span>
                </button>
              </div>
            </Form>
            <Form v-else @submit="verify">
              <h4 style="color: #fff">{{$t('auth.two_step_verification')}}</h4>
              <p style="color: #fff">{{$t('auth.google_authenticator')}}</p>
              <ul>
                <li>
                  <label for="">{{$t('auth.google_auth_code')}}</label>
                  <Field
                    autocomplete="off"
                    class="form-control"
                    name="form.google_token"
                    rules="required|min:6|max:6|numeric"
                    v-model="form.google_token"
                  />
                  <ErrorMessage name="form.google_token" style="color:white" />
                </li>
              </ul>
              <div class="btn-holder">
                <button type="submit" class="btn btn-yellow">
                  <span>{{$t('auth.submit')}}</span>
                </button>
              </div>
            </Form>
          </div>
          <div class="links">
            <p>{{$t('auth.dont_have_account')}}</p>
            <router-link to="/register">{{$t('auth.create_account_now_CAP')}}</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useMainStore } from "@/store";
import { Form, Field, ErrorMessage } from "vee-validate";
import vueRecaptcha from 'vue3-recaptcha2';
import language from '@/components/shared/language';
export default {
  setup() {
    const store = useMainStore();
    return { store };
  },
  mounted() {
    this.store.getCountriesList();
  },
  data() {
    return {
        form: {
            email: "",
            password: "",
            google_token: "",
        },
        showpassword: false,
        iconType : 'eye-off',
        inputtype : 'password',
        captcha_code : ''
                
    };
  },
  components: {
    Form,
    Field,
    ErrorMessage,
    vueRecaptcha,
    appLanguage: language,
  },
  methods: {
    recaptchaVerified(response) {
      this.captcha_code = response
    },
    recaptchaExpired() {
      this.$refs.vueRecaptcha.reset();
      this.captcha_code = ''
    },
    recaptchaFailed() {
      this.captcha_code = ''
    },
    recaptchaError() {
      this.captcha_code = ''
    },
    submit() {
      this.store.login({...this.form,'g-recaptcha-response':this.captcha_code}, true);
      this.$refs.vueRecaptcha.reset();
      this.captcha_code = ''
    },
    switchVisibility() {
        this.showpassword = !this.showpassword
        if(this.showpassword){
            this.inputtype = 'text'
            this.iconType = 'eye'
        }else{
            this.inputtype = 'password'
            this.iconType = 'eye-off'
        } 
    },
    verify() {
      this.store.verifyLogin({...this.form,'g-recaptcha-response':this.captcha_code}, true);
    },
  },
};
</script>
